<template>
  <page :setup="setup">
    <container-layout
      :menu="menu"
      :showAside="false"
      @selectMainMenu="selectMenu"
      router
      :defaultMenu="defaultMenu"
    >
      <template v-slot:main>
        <div class="task-history-wrapper">
          <div class="tsk-history-top">
            <p class="title"></p>
            <div class="search">
              <p>关键字搜索：</p>
              <el-input
                v-model="keyWord"
                placeholder="关键字"
                @change="getHistoryCoworkList({ page: 0 })"
              ></el-input>
              <el-button
                type="primary"
                @click="getHistoryCoworkList({ page: 0 })"
                >查询</el-button
              >
            </div>
          </div>

          <pagination-table
            :data="data"
            :columns="columns"
            :actions="actions"
            :loader="getHistoryCoworkList"
            :async="true"
            :pageSizes="[10]"
            class="dot-table"
          ></pagination-table>
        </div>
        <detail-dialog
          :visible.sync="detailVisible"
          @close="closeDetailDialog"
          :id="id"
        ></detail-dialog>
      </template>
    </container-layout>
  </page>
</template>
<script>
import { getToken } from '@/utils';
import DetailDialog from './component/detail-dialog';
import { getMenu } from './util';
export default {
  components: { DetailDialog },
  data() {
    return {
      keyWord: '',
      defaultMenu: '/task/history',
      detailVisible: false,
      data: [],
      columns: [
        {
          prop: 'workName',
          label: '项目名称'
        },
        {
          prop: 'name',
          label: '创建人',
          width: '200px'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '180px'
        },
        {
          prop: 'timestamp',
          label: '完成时间',
          width: '180px'
        }
      ],
      actions: [
        {
          label: '详情',
          type: 'success',
          style: 'btn',
          plain: true,
          onClick: (index, row) => {
            this.id = row.workId;
            //console.log(this.id, 'this.id...');
            this.detailVisible = true;
          }
        },
        {
          label: '下载',
          type: 'success',
          style: 'link',
          href: (index, row) => {
            return `${
              process.env.VUE_APP_API_HOST_WORK
            }/cowork/project/coworkDown?apiKey=${getToken()}&workId=${
              row.workId
            }`;
          }
        }
      ]
    };
  },
  computed: {
    menu() {
      return getMenu(code => this.$hasPermission(code));
    }
  },
  methods: {
    setup() {},

    closeDetailDialog() {
      this.detailVisible = false;
    },
    selectMenu() {},
    async getHistoryCoworkList(options) {
      const { data } = await this.$fetch.get(
        '/cowork/project/getHistoryCoworkList',
        {
          module: 'work',
          params: { pageNo: options.page, search: this.keyWord }
        }
      );
      const { data: resData } = data;
      //console.log(resData, 'this.data//table');
      this.data = resData.rows.map(item => {
        if (item.state === 0) {
          item.state = '撰写中';
        } else if (item.state === 5) {
          item.state = '完成';
        } else {
          item.state = '检阅中/验查中/会签中/核定中';
        }
        return item;
      });
      return {
        data: this.data,
        total: resData.total
      };
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-button--primary:focus,
.el-button--primary:hover {
  background-color: #3271a1;
  border-color: #3271a1;
}
.task-history-wrapper {
  padding: 0px 28px;
  .tsk-history-top {
    display: flex;
    justify-content: space-between;
    .title {
      color: #ffffff;
    }

    .search {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;

      p {
        width: 130px;
      }
    }
  }
  /deep/.control {
    margin-right: 0 !important;
  }
}
/deep/.container-layout .container-layout-content > .el-main {
  border: none !important;
}
</style>
